import React, { Component } from "react";
export class Hero extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="hero">
          <div className="overlay" style={this.props.style}></div>
          <img className="imgbg" src={this.props.image} alt="" />
          <div className="hero-content">
            <h1 className="heading-1">
              {this.props.heading}
            </h1>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Hero;
